import { isFormValid } from '../../../../library/Core/SmartFunctions';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import logger from '../../../../library/Core/logger';
import ScreenNavigationService, { AlumniProfileEditScreens } from '../../../../services/screen-navigation.service';
// import { toStudentEntity } from '../../../../services/student-mapper.service';
import StudentService from '../../../../services/student.service';
import axios from 'axios';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';

export const handleNext = (
     event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();

    const recruiterInfo = state?.data?.recruiterInfo || {};
    const recruiterBecomeInfo = {
    ...recruiterInfo,
     recruiterProfile:
        recruiterInfo.email && recruiterInfo.mobileNumber
        ? 'MARKED_AS_RECRUITER'
        : 'POTENTIAL_RECRUITER',
     };
    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        recruiterInfo
    ).then(() => {
        if (state?.data?.userStatusCode != 'ACTIVE') {
            state.actions['ROUTER_NAVIGATE'](`/alumni/${state.routeInfo.id}/${AlumniProfileEditScreens.BASIC_INFORMATION}`);
        } else {
            state.actions['ROUTER_NAVIGATE'](`/alumni/${state.routeInfo.id}/profile/${AlumniProfileEditScreens.UG_JOURNEY}`);
        }
    });
};

export const handleCompleteLater = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:block');
};
